import React from 'react'
import { useFragment, graphql } from 'react-relay/hooks'
import { FlexRow, Text, Dropdown, LinkButton, Icon, Table } from 'elements'
import { useModals } from 'hooks'
import EditTemplateModal from './EditTemplateModal'
import useReportTemplateArchive from './hooks/useReportTemplateArchive'

const { Row, Cell } = Table.Card

export default function TemplateRow(props) {
  const { openModal } = useModals()
  const [archiveReportTemplate] = useReportTemplateArchive()

  const template = useFragment(
    graphql`
      fragment TemplateRow_reportTemplate on ReportTemplate {
        id
        name
        config
        deletedAt
        organization {
          defaultReportSections
        }
      }
    `,
    props.template,
  )

  if (!props.template) {
    return null
  }

  const handleDelete = async () => {
    await archiveReportTemplate({ templateId: template.id })
  }

  const dropdownOptions = [
    {
      label: 'Edit',
      onSelect: () =>
        openModal(
          EditTemplateModal,
          { template, defaultReportSections: template.organization.defaultReportSections },
          'semi',
        ),
    },
    { label: 'Delete', kind: 'danger', onSelect: handleDelete },
  ]

  return (
    <Row
      interactive
      onClick={() =>
        openModal(
          EditTemplateModal,
          { template, defaultReportSections: template.organization.defaultReportSections },
          'semi',
        )
      }
    >
      <Cell>
        <Text fontSize="large" lineHeight="large" fontWeight="bold">
          {template.name}
        </Text>
      </Cell>
      <Cell>
        <FlexRow justifyContent="flex-end">
          <Dropdown
            position="bottom right"
            options={dropdownOptions}
            stopPropagation
            renderButton={() => (
              <LinkButton kind="transparent">
                <Icon size="medium" name="dots-horizontal" color="neutral.2" />
              </LinkButton>
            )}
          />
        </FlexRow>
      </Cell>
    </Row>
  )
}
